export const serializeError = (error: any) => ({
    message: error.message || error.toString(),
    name: error.name || "Error",
    stack: error.stack,
    details: error.details || {}
})
